import Cookies from "universal-cookie";
import { SocketCommand, socketManager } from "../../components/AppProvider";

const cm = new Cookies();

export const getCookie = (key) => {
  return cm.get(key);
};

export const setCookie = (key, value, maxAge) => {
  let max = parseInt(maxAge) * 24 * 60 * 60;

  if (max >= 0) cm.set(key, value, { path: "/", sameSite: "lax", maxAge: max });
  else cm.set(key, value, { path: "/", sameSite: "lax" });
};

export const setCookies = (cookies, maxAge) => {
  const keys = Object.keys(cookies);
  let max = parseInt(maxAge) * 24 * 60 * 60;
  for (let i in keys) {
    const k = keys[i];
    const v = cookies[k];

    // maxAge=유효기간 일주일 기준(7*24*60*60)
    if (max >= 0) cm.set(k, v, { path: "/", sameSite: "lax", maxAge: max });
    else cm.set(k, v, { path: "/", sameSite: "lax" });
  }
};

// 쿠키 전체 삭제하기
export const allDelCookies = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

    if (
      !(
        name.trim() === "signUpChannel" ||
        name.trim() === "userEmail" ||
        name.trim() === "lastLoginChannel" ||
        name.trim() === "userId"
      )
    ) {
      document.cookie = name + "=;max-age=0";
    }
  }
};

export const allCookieClear = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

    document.cookie = name + "=;max-age=0";
  }
};

export const getCookies = (keys) => {
  const cookies = {};
  for (let i in keys) {
    const key = keys[i];
    cookies[key] = getCookie(key);
  }
  return cookies;
};

export const getAuth = () => {
  return cm.get("authorization");
};

export const setAuth = (maxAge) => {
  let max = parseInt(maxAge) * 24 * 60 * 60;
  if (max >= 0) cm.set("authorization", "auth", { path: "/", sameSite: "lax", maxAge: max });
  else cm.set("authorization", "auth", { path: "/", sameSite: "lax" });
};

export const clearAuth = () => {
  cm.set("authorization", "", { path: "/", sameSite: "lax" });
};

export const isLogin = () => {
  if (!getAuth()) {
    return false;
  }
  return true;
};

// 신규 쿠키 관리(웹소켓 사용, 네이티브 보관) START
// key type is array
// [userName, userToken]
export const getCookieNew = (key) => {
  const splitCookie = document.cookie.split("; ");
  const endCnt = key.length;

  let returnVal = {};
  for (let i = 0; i < endCnt; i++) {
    let name = key[i].toString();

    for (let z = 0; z < splitCookie.length; z++) {
      if (name === splitCookie[z].split("=")[0]) {
        let value = splitCookie[z].split("=")[1];
        returnVal[name] = decodeURI(value);
        break;
      }
    }
  }
  return returnVal;
};

export const setCookieNew = (value) => {
  const setValue = value.split("; ");

  for (let i = 0; i < setValue.length; i++) {
    document.cookie = encodeURI(setValue[i]);
  }
  socketManager(SocketCommand.SET_COOKIE, undefined, value);
};

export const setCookieWs = (setValue) => {
  // let copyCookie = getCookieWs();
  socketManager(SocketCommand.SET_COOKIE, undefined, {
    type: "set",
    cookieData: JSON.stringify(setValue),
  });
};

export const getCookieWs = (getCookieEvent) => {
  socketManager(SocketCommand.SET_COOKIE, getCookieEvent, { type: "get", cookieData: "" });
};

export const lastLoginInfo = data => {
  if (data.isResult === 200) {
    // let jsonData = JSON.parse(data.cookieData);
    let jsonData = data.cookieData;
    if (jsonData.signUpChannel == "000") {
      $("input[name='email']").val(jsonData.userEmail);
    } else {
      setCookie("signUpChannel", jsonData.signUpChannel, 1);
    }
  } else {
    if (getCookie("signUpChannel").toString() === "000") {
      $("input[name='email']").val(getCookie("userEmail"));
    } else {
      setCookie("signUpChannel", getCookie("signUpChannel").toString(), 1);
    }
  }
};

export const getLoginInfo = data => {
  if (data.isResult === 200) {
    let jsonData = JSON.parse(data.cookieData);
    setCookies(jsonData.loginInfo);
  }
};
// 신규 쿠키 관리(웹소켓 사용, 네이티브 보관) END

export const setExpire = (value) => {
  let date = new Date();
  date.setDate(date.getDate() + value);

  let yyyy = date.getFullYear();
  var mm = date.getMonth() + 1;
  var dd = date.getDate();

  if (mm < 10) {
    mm = "0" + mm;
  }
  if (dd < 10) {
    dd = "0" + dd;
  }

  return yyyy + "" + mm + "" + dd;
};

export default {
  set: setCookie,
  get: getCookie,
  setCookies,
  getCookies,
  getAuth,
  setAuth,
  clearAuth,
  isLogin,
};
